var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_3215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41158 18.0002C6.16385 18.0002 4.96723 17.5261 4.08496 16.6822C3.20269 15.8383 2.70703 14.6937 2.70703 13.5002C2.70703 12.3067 3.20269 11.1621 4.08496 10.3182C4.96723 9.4743 6.16385 9.0002 7.41158 9.0002C7.70626 7.68737 8.56834 6.53368 9.80816 5.79291C10.4221 5.42612 11.1102 5.17174 11.8334 5.04431C12.5565 4.91687 13.3004 4.91887 14.0227 5.0502C14.745 5.18152 15.4314 5.43959 16.0429 5.80968C16.6543 6.17976 17.1788 6.65461 17.5863 7.20712C17.9939 7.75963 18.2765 8.37898 18.4181 9.02979C18.5597 9.68061 18.5575 10.3502 18.4116 11.0002H19.4116C20.3398 11.0002 21.2301 11.3689 21.8865 12.0253C22.5428 12.6817 22.9116 13.5719 22.9116 14.5002C22.9116 15.4285 22.5428 16.3187 21.8865 16.9751C21.2301 17.6314 20.3398 18.0002 19.4116 18.0002H18.4116",
    stroke: "#082E56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41211 15L12.4121 12L15.4121 15",
    stroke: "#082E56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4121 12V21",
    stroke: "#082E56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_3215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.412109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImgIcon);
export default __webpack_public_path__ + "static/media/upload-img-icon.f85f1247118808e360d8d3725ff26a02.svg";
export { ForwardRef as ReactComponent };